"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var environmentallyFriendly = function (_a) {
    var production = _a.production, nonProduction = _a.nonProduction;
    return process.env.NODE_ENV === 'production' ? production : nonProduction;
};
exports.default = environmentallyFriendly;
